// utils/tooltipObserver.js

/**
 * Initializes a MutationObserver to add location-specific classes
 * to Vuetify's v-overlay__content elements.
 * This allows for CSS rules to target tooltips based on their 'location'.
 *
 * @param {HTMLElement} rootElement The DOM element to observe (e.g., document.body or your main #app div).
 */

const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
      const targetElement = mutation.target;

      // Check if the mutated element is a v-overlay__content

      if (targetElement.classList.contains('v-overlay__content') &&
        targetElement.classList.contains('custom-tooltip-with-arrow')) {
        const style = targetElement.style;
        const anchorOrigin = style.getPropertyValue('--v-overlay-anchor-origin');
        // console.log('Anchor Origin:', anchorOrigin);

        // Remove any existing location classes to ensure only one is present
        targetElement.classList.remove(
          'v-overlay__content--location-top',
          'v-overlay__content--location-bottom',
          'v-overlay__content--location-start',
          'v-overlay__content--location-end'
        );

        // Determine the location based on --v-overlay-anchor-origin
        // This mapping needs to be accurate based on Vuetify's internal logic
        if (anchorOrigin) {
          let locationClass = '';
          if (anchorOrigin.includes('top')) {
            // Tooltip is below the activator, arrow points up. Corresponds to location="bottom".
            locationClass = 'v-overlay__content--location-bottom';
          } else if (anchorOrigin.includes('bottom')) {
            // Tooltip is above the activator, arrow points down. Corresponds to location="top".
            locationClass = 'v-overlay__content--location-top';
          } else if (anchorOrigin.includes('left')) {
            // Tooltip is to the right of activator, arrow points left. Corresponds to location="end".
            locationClass = 'v-overlay__content--location-start';
          } else if (anchorOrigin.includes('right')) {
            // Tooltip is to the left of activator, arrow points right. Corresponds to location="start".
            locationClass = 'v-overlay__content--location-end';
          }

          if (locationClass) {
            targetElement.classList.add(locationClass);
          }
        }
      }
    }
  }
});

// Start observing the entire document body for changes in child nodes and their subtrees.
// Observing document.body is generally appropriate for global overlays like tooltips.
observer.observe(document.body, {
  attributes: true,          // Watch for attribute changes
  subtree: true,             // Watch for changes in descendants as well
  attributeFilter: ['style'] // Only watch changes to the 'style' attribute for performance
});
